module.exports = __webpack_public_path__ + "img/JCB_logo.b7f84708.svg";